import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { KeyInitiativeEditorWrapper } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives'
import { selectProgramType } from 'legacy/lut/features/partner360/configuration'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Nullable } from 'clickNgo/models/utils'
import { getUrlWithParams } from 'core-components/helpers/url'
import { EventBusController } from 'core-components/sitebuilder/layout/content/libraryContent/EventBusController'
import MeasureController from 'core/analytics/MeasureController'

import {
  AMPLIFY_IMPACT_INFO_EVENT_BUS,
  AMPLIFY_IMPACT_INFO_EVENTS,
} from './constants/amplifyImpactInfoEventBus'
import {
  KEY_INITIATIVES_SCROLL_OFFSET,
  KEY_INITIATIVES_TAB_ID,
  KEY_INITIATIVES_TAB_PARAM,
  KEY_INITIATIVES_TABS_ELEMENT_ID,
} from './constants/keyInitiativesTab'
import { AmplifyImpactInfoEvents } from './models/amplifyImpactInfoEvents'

export const AmplifyImpactKeyInitiativeEditor = () => {
  const [isDialogOpened, setIsDialogOpened] = useState<boolean>(false)
  const [metrics, setMetrics] = useState<Nullable<MeasureController>>(null)
  const programType = useSelector(selectProgramType)
  const navigate = useNavigate()

  const amplifyImpactInfoEventBus = useMemo(() => {
    return EventBusController.getEventBus(AMPLIFY_IMPACT_INFO_EVENT_BUS, AMPLIFY_IMPACT_INFO_EVENTS)
  }, [])

  const isRetail = useMemo(() => {
    return programType === ProgramTypes.Retail
  }, [programType])

  const openKeyInitiativesTab = useCallback(() => {
    const element = document.getElementById(KEY_INITIATIVES_TABS_ELEMENT_ID)

    if (element) {
      const [rect] = element.getClientRects()

      window.scrollTo({
        top: rect.y - KEY_INITIATIVES_SCROLL_OFFSET,
      })
    }

    navigate(getUrlWithParams({ [KEY_INITIATIVES_TAB_PARAM]: KEY_INITIATIVES_TAB_ID }))
  }, [navigate])

  const closeKeyInitiativeEditor = useCallback(() => {
    setIsDialogOpened(false)
    openKeyInitiativesTab()
  }, [openKeyInitiativesTab])

  const handleLoadingStateChange = useCallback(
    (isEditorLoading: boolean) => {
      amplifyImpactInfoEventBus.notify(
        AmplifyImpactInfoEvents.keyInitiativeEditorLoadingChanged,
        isEditorLoading
      )
    },
    [amplifyImpactInfoEventBus]
  )

  useEffect(() => {
    return amplifyImpactInfoEventBus.subscribe(
      AmplifyImpactInfoEvents.keyInitiativeEditorRequested,
      (_event, widgetMetrics: MeasureController) => {
        setMetrics(widgetMetrics)
        setIsDialogOpened(true)
      }
    )
  }, [amplifyImpactInfoEventBus])

  if (!metrics) {
    return null
  }

  return (
    <KeyInitiativeEditorWrapper
      isAmplifyImpactInfoSection={true}
      metrics={metrics}
      isDialogOpened={isDialogOpened}
      isDataInsightPresent={!isRetail}
      onLoadingStateChange={handleLoadingStateChange}
      onEditCancel={closeKeyInitiativeEditor}
      onUpdateFinished={closeKeyInitiativeEditor}
    />
  )
}
